export class IdentityResolverError extends Error {
  name = 'IdentityResolverError'
}
